/* WM load-more for homepage featured-collection grids.
   First 12 products are server-rendered. Each click fetches the next page of the same
   section via the Section Rendering API (?section_id=...&page=N) and appends the cards.
   After data-max-loads clicks, or when the collection has no more pages, the button
   becomes a plain link to the collection (label = section "show_more_product_text").
   Without JS the button is a normal link to the collection. */
(function () {
  if (window.customElements.get('wm-load-more')) return;

  if (!document.getElementById('wm-load-more-style')) {
    var st = document.createElement('style');
    st.id = 'wm-load-more-style';
    st.textContent =
      'wm-load-more a[aria-busy="true"]{opacity:.65;cursor:progress;pointer-events:none}' +
      'wm-load-more a{min-width:var(--wm-lm-w,auto);justify-content:center}';
    document.head.appendChild(st);
  }

  class WmLoadMore extends HTMLElement {
    connectedCallback() {
      if (this._wmInit) return;
      this._wmInit = true;
      this.link = this.querySelector('a');
      this.grid = document.getElementById(this.dataset.grid);
      if (!this.link || !this.grid) return;
      this.page = parseInt(this.grid.dataset.wmLmPage, 10) || 1;
      this.pages = parseInt(this.grid.dataset.wmLmPages, 10) || 1;
      this.maxLoads = parseInt(this.dataset.maxLoads, 10) || 2;
      this.loads = 0;
      this.busy = false;
      this.label = this.link.querySelector('span') || this.link;
      if (this.page >= this.pages) { this.toLink(); return; }
      this.link.setAttribute('role', 'button');
      this.link.setAttribute('aria-controls', this.grid.id);
      this._onClick = this.onClick.bind(this);
      this.link.addEventListener('click', this._onClick);
    }

    onClick(e) {
      if (this.mode === 'link') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
      e.preventDefault();
      if (this.busy) return;
      this.load();
    }

    url(page) {
      var u = new URL(window.location.pathname, window.location.origin);
      u.searchParams.set('section_id', this.dataset.sectionId);
      u.searchParams.set('page', String(page));
      return u.toString();
    }

    setBusy(on) {
      this.busy = on;
      if (on) {
        this.style.setProperty('--wm-lm-w', this.link.offsetWidth + 'px');
        this._txt = this.label.textContent;
        this.label.textContent = 'טוען...';
        this.link.setAttribute('aria-busy', 'true');
      } else {
        this.link.removeAttribute('aria-busy');
        if (this.mode !== 'link' && this._txt != null) this.label.textContent = this._txt;
        this.style.removeProperty('--wm-lm-w');
      }
    }

    async load() {
      var next = this.page + 1;
      this.setBusy(true);
      try {
        var res = await fetch(this.url(next), { credentials: 'same-origin' });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.getElementById(this.grid.id);
        if (!g) throw new Error('grid not found');
        var have = new Set();
        this.grid.querySelectorAll('[data-product-card-id]').forEach(function (el) { have.add(el.getAttribute('data-product-card-id')); });
        var frag = document.createDocumentFragment();
        var added = 0;
        var firstNew = null;
        Array.prototype.slice.call(g.children).forEach(function (li) {
          if (li.tagName !== 'LI') return;
          var c = li.querySelector('[data-product-card-id]');
          var pid = c && c.getAttribute('data-product-card-id');
          if (pid && have.has(pid)) return;
          if (pid) have.add(pid);
          var node = document.importNode(li, true);
          if (!firstNew) firstNew = node;
          frag.appendChild(node);
          added++;
        });
        this.grid.appendChild(frag);
        this.reveal(firstNew);
        this.page = next;
        this.pages = parseInt(g.dataset.wmLmPages, 10) || this.pages;
        this.loads++;
        this.dispatchEvent(new CustomEvent('wm:load-more', { bubbles: true, detail: { page: next, added: added } }));
        if (!added || this.page >= this.pages || this.loads >= this.maxLoads) this.toLink();
        this.setBusy(false);
      } catch (err) {
        this.setBusy(false);
        this.toLink();
        window.location.href = this.link.href;
      }
    }

    // Homepage rows are horizontal scrollers: bring the first new card into view inside the row.
    reveal(el) {
      var ul = this.grid;
      if (!el || ul.scrollWidth <= ul.clientWidth + 2) return;
      requestAnimationFrame(function () {
        try {
          // horizontal only (no vertical page jump); RTL-aware: inline start is the right edge
          var cs = getComputedStyle(ul), r = el.getBoundingClientRect(), u = ul.getBoundingClientRect();
          var d = cs.direction === 'rtl'
            ? r.right - (u.right - (parseFloat(cs.paddingRight) || 0))
            : r.left - (u.left + (parseFloat(cs.paddingLeft) || 0));
          if (Math.abs(d) > 1) ul.scrollBy({ left: d, behavior: 'smooth' });
        } catch (e) {}
      });
    }

    toLink() {
      this.mode = 'link';
      this.link.removeAttribute('role');
      this.link.removeAttribute('aria-controls');
      if (this.dataset.allLabel) this.label.textContent = this.dataset.allLabel;
    }
  }

  window.customElements.define('wm-load-more', WmLoadMore);
})();
